<script>
import { mapActions } from 'vuex';
import axios from 'axios';
import { result } from 'lodash';
import snackbarMixin from '@/mixins/snackbar';
import html2canvas from 'html2canvas';
import RbxFileUpload from '../../RbxFileUpload';

export default {
  name: 'FeedbackButton',
  components: {
    RbxFileUpload,
  },
  mixins: [snackbarMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      feedbackText: '',
      screenshotId: null,
      isProcessing: false,
      base64URL: null,
      isTakingScreenshot: false,
    };
  },
  methods: {
    ...mapActions('feedbackButton', ['closeDialog', 'cleanFeedback']),
    submit() {
      const self = this;

      if (!this.feedbackText) {
        self.showErrorMessage('Bitte geben Sie eine Beschreibung ein.');

        return;
      }
      this.isProcessing = true;
      axios.post('feedback', { feedbackText: this.feedbackText, screenshotId: this.screenshotId, image: this.base64URL })
        .then(() => {
          self.showSuccessMessage('Vielen Dank, für Ihr Feedback.');
          self.closeDialog();
          self.feedbackText = '';
          self.screenshotId = null;
        }).catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Das Feedback konnte aufgrund eines Fehlers nicht gesendet werden.');
          self.showErrorMessage(message);
        }).then(() => {
          self.isProcessing = false;
        });
    },
    close() {
      this.feedbackText = '';
      this.screenshotId = null;
      this.closeDialog();
    },
    onUpload(files) {
      let serverId;

      if (files && files.length > 0) {
        serverId = files[0].serverId; // eslint-disable-line
        this.screenshotId = JSON.parse(serverId).data.id;
      }
    },
    onScreenshot() {
      this.isTakingScreenshot = true;
      html2canvas(document.getElementsByClassName('application--wrap')[0])
        .then((canvas) => {
          document.body.appendChild(canvas);
          this.base64URL = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream');
          this.showSuccessMessage('Screenshot wurde aufgenommen.');
          this.isTakingScreenshot = false;
        })
        .catch(() => {
          this.isTakingScreenshot = false;
        });
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card v-if="visible">
      <v-card-title class="title pa-3">
        Feedback senden
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12 xs12>
              <v-layout row wrap>

                <v-flex xs12 md12 py-0>
                  <v-textarea
                    v-model="feedbackText"
                    label="Optimierungsvorschlag / Fehler"
                    height="88"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md12>
                  <span style="color: #757575; font-size: 10px important;">
                    Bitte fügen Sie Ihrer Beschreibung einen Screenshot an,
                    damit Ihr Feedback schneller und ohne Rückfragen bearbeitet werden kann.
                    Sie können selbst einen Screenshot machen und manuell
                    hochladen oder den Kamera-Button drücken. In diesem Fall wird ein Screenshot
                    vom aktuellen Browserinhalt (ohne Popup) gemacht und Ihrer Nachricht beigefügt.
                  </span>

                  <br>

                  <center>
                    <v-btn v-if="isTakingScreenshot" small flat icon>
                      <v-icon color="amber">camera_alt</v-icon>
                    </v-btn>

                    <v-btn v-else @click="onScreenshot" small flat icon>
                      <v-icon style="camera_enhanced">camera_alt</v-icon>
                    </v-btn>
                  </center>

                  <RbxFileUpload
                    height="100"
                    domain=""
                    action="screenshot"
                    :accepted-types="'image/jpeg, image/jpg, image/png'"
                    :allow-multiple="false"
                    @uploaded="onUpload"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               :disabled="isProcessing"
               color="blue"
               flat>
          Absenden
        </v-btn>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
